// extracted by mini-css-extract-plugin
export var columnList = "_ca-0";